document.addEventListener('DOMContentLoaded', function () {
  var customSizeBtn = document.getElementById('customSizeBtn');
  var customSizeForm = document.getElementById('customSizeForm');
  var cancelOrderText = document.getElementById('cancelOrderText');

  if (customSizeBtn && customSizeForm && cancelOrderText) {
    customSizeBtn.addEventListener('click', function () {
      customSizeForm.classList.remove('hidden-form');
      customSizeForm.style.display = 'block';
      customSizeBtn.style.display = 'none';
    });

    cancelOrderText.addEventListener('click', function (event) {
      event.preventDefault();
      if (customSizeForm.parentNode) {
        customSizeForm.parentNode.removeChild(customSizeForm);
      }
      if (customSizeBtn.parentNode) {
        customSizeBtn.parentNode.removeChild(customSizeBtn);
      }
    });
  }
});
